import { ObservableMap } from '@stencil/store';
import { getEnvironment } from '@uipath/portal-shell-util';

import { isFalselyOrWhiteSpace } from '../store/common';
import { State } from '../store/types/state';
import {
    getEnvConfigField,
    isMsi,
} from './EnvironmentUtil';
import Logger from './logger/logger';
import {
    getAccountName,
    getBaseUrl,
} from './urlHelper';

export function getOrganizationStandardUrl(
    store: ObservableMap<State>, {
        isPrivateShellRoute = false,
        shouldUseDefaultBaseUrl = false,
    } = {},
) {
    if (isMsi(store)) {
        return getBaseUrl();
    }

    let organizationStandardUrl = store.get('organizationStandardUrl');
    if (!organizationStandardUrl && store.get('mode') !== 'dev-cloud') {
        organizationStandardUrl = store.get('baseUrl');

        const isLocalOrgStandardUrl = organizationStandardUrl?.includes('localhost:') || organizationStandardUrl?.includes('127.0.0.1:');
        if (shouldUseDefaultBaseUrl && isLocalOrgStandardUrl) {
            organizationStandardUrl = getEnvConfigField('DEFAULT_BASE_URL');
        }

        let accountName = store.get('accountName');
        if (isFalselyOrWhiteSpace(accountName)) {
            accountName = getAccountName() ?? '';
            Logger.debug([ 'orgStandardUrl', 'fallback' ], 'Found empty account name, falling back to url : ' + accountName);
        }

        if (organizationStandardUrl && accountName && (isPrivateShellRoute || getEnvironment() !== 'k8s')) {
            organizationStandardUrl += `/${accountName}`;
        }
    }
    Logger.debug('orgStandardUrl', 'organizationStandardUrl: ' + organizationStandardUrl);
    return organizationStandardUrl;
}

export function parseOrganizationStandardUrl(organizationStandardUrl: string) {
    const url = new URL(organizationStandardUrl);
    return {
        baseUrl: url.origin,
        accountName: url.pathname.split('/')[1],
    };
}
